import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("p", null, "buy at: " + _toDisplayString(_ctx.ttData[2]) + " Value: " + _toDisplayString(_ctx.ttData[3]), 1),
    _createElementVNode("p", null, "sell at: " + _toDisplayString(_ctx.ttData[0]) + " Value: " + _toDisplayString(_ctx.ttData[1]), 1),
    _createElementVNode("p", null, "profit if buying and selling 1 bitcoin: " + _toDisplayString(_ctx.ttData[4]) + " Euros", 1)
  ], 64))
}